export enum MessageType {
  Normal,
  Image,
  Invite,
}

export namespace MessageType {
  export function getTypeFromString(str: string): MessageType {
    str = str.toUpperCase()

    switch (str) {
      case 'INVITE':
        return MessageType.Invite
      case 'IMAGE':
        return MessageType.Image
      default:
        return MessageType.Normal
    }
  }

  export function toString(type: MessageType): string {
    switch (type) {
      case MessageType.Normal:
        return 'NORMAL'
      case MessageType.Image:
        return 'IMAGE'
      case MessageType.Invite:
        return 'INVITE'
      default:
        return null
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/chatroom/shared/message-type.enum.ts